import without from 'lodash/without'

// Feedable type 的字串定義 Feedable model 的 class name
export const PODCAST_EPISODE = 'PodcastEpisode'
export const TWEET = 'Tweet'
export const EARNINGS_CALL = 'Stock::US::EarningsCall'
export const ANNOUNCEMENT = 'News::MopsAnnouncement'
export const US_YAHOO_NEWS = 'Stock::US::YahooNews'
export const STATEMENTDOG_NEWS = 'News'
export const YAHOO_STOCK_FEED = 'News::YahooStockFeed'
export const SEC_FILING = 'Stock::US::SECFiling'
export const SEEKING_ALPHA_FEED = 'Stock::US::SeekingAlphaFeed'
export const INDUSTRY_REPORT = 'IndustryReport'
// 自定義 type 股價變動解釋
export const STOCKS_MOVES = 'StocksMoves'

export const ALL = [
  PODCAST_EPISODE,
  TWEET,
  EARNINGS_CALL,
  ANNOUNCEMENT,
  US_YAHOO_NEWS,
  STATEMENTDOG_NEWS,
  YAHOO_STOCK_FEED,
  SEC_FILING,
  SEEKING_ALPHA_FEED,
  INDUSTRY_REPORT,
  STOCKS_MOVES,
]

export const ALL_FOR_ANALYSIS = without(ALL, PODCAST_EPISODE, STATEMENTDOG_NEWS, INDUSTRY_REPORT)
